import { sectionLabels } from "../section-labels";
/**
 * Customer reviews — locked. The reviews block on the PDP. Split out as its own
 * PDP section so the seller can toggle it independently. Not `criticalForSeo`
 * (peripheral content, not the product itself). Lives under `templates.product`
 * only.
 */
export const productReviewsSchema = {
    type: "product-reviews",
    name: sectionLabels["product-reviews"],
    description: {
        ar: 'قسم "تقييمات العملاء" أسفل صفحة المنتج.',
        en: "The customer-reviews block shown on the product page.",
    },
    locked: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["product"],
    settings: [
        {
            id: "showReviews",
            type: "checkbox",
            label: { ar: 'إظهار "تقييمات العملاء"', en: 'Show "Customer reviews"' },
            default: true,
        },
        {
            id: "reviewsLayout",
            type: "select",
            label: { ar: "شكل قسم التقييمات", en: "Reviews layout" },
            helpText: {
                ar: "بطاقة ملخص بالنجوم والتوزيع، أو تخطيط متمركز، أو بسيط بمحاذاة لليسار.",
                en: "A summary card with stars + distribution, a centered layout, or a minimal left-aligned block.",
            },
            options: [
                { value: "summary", label: { ar: "بطاقة ملخص", en: "Summary card" } },
                { value: "centered", label: { ar: "متمركز", en: "Centered" } },
                { value: "minimal", label: { ar: "بسيط", en: "Minimal" } },
            ],
            default: "summary",
            showIf: { showReviews: true },
        },
    ],
};
//# sourceMappingURL=product-reviews.js.map